import { useContext } from 'react'
import { State } from '../utils/context'
import Verse from '../components/verse'
import Chip from '../components/chip'
import Results from './results'
import styles from './verses.module.css'

const ERROR = 'Nie udało się wczytać tekstu. Sprawdź połączenie z internetem.'

const Verses = () => {
  const [{output, status, search, active}, setState] = useContext(State)

  const onClick = id => setState(state => ({
    ...state,
    active: {
      ...state.active,
      verses: {
        ...state.active.verses,
        [id]: !state.active.verses[id]
      }
    }
  }))

  const onBack = () => setState(state => ({
    ...state,
    active: {
      ...state.active,
      search: true,
      verses: {}
    }
  }))

  return (
    <div className={styles.verses}>
      {!active.search && search.back && (
        <div className={styles.back}>
          <Chip onClick={onBack}>← Wyniki: {search.query.trim()}</Chip>
        </div>
      )}
      {active.search
        ? <Results />
        : status == 'error'
          ? <div className={styles.info}>{ERROR}</div>
          : Object.entries(output).map(([id, text]) => (
            <Verse
              key={id}
              active={active.verses[id]}
              onClick={() => onClick(id)}
              id={id}
            >
              {text}
            </Verse>
          ))
      }
    </div>
  )
}

export default Verses
